import { useField } from '@framework/form/field/useField.tsx';
import { useController } from '@framework/form/hooks/useController.ts';
import { useEffect } from 'react';
import styled from 'styled-components';

const HiddenComponent = styled.div`
  visibility: hidden;
`;

export interface IHiddenPaymentRowFieldProps {
  name: string;
  value: number | null;
  readonly: boolean;
}

/**
 * Permette di gestire il valore di una voce di costo nel form mantenendo
 * il campo nascosto.
 */
export function HiddenPaymentRowField(props: IHiddenPaymentRowFieldProps) {
  const { name, value, readonly } = props;

  const { field } = useController(name);

  const { setValue } = useField(name);

  useEffect(() => {
    if (readonly) return;
    if (value !== field.value) {
      setValue(value, {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false,
      });
    }
  }, [value, field.value, readonly, setValue]);

  return <HiddenComponent {...field} />;
}
